import styled from 'styled-components'

export const Page = styled.div`
  height: 100%;
  background-color: white;
  
  .headContainer {
    display: flex;
    flex-direction: row;
    
    .title {
      padding-left: 1rem;
    }
  }
  
  .navbar {
    position: relative !important;
  }
  
  .modal-center {
    display: flex;
    justify-content: center;
  }
  
  .hidden {
    display: none;
  }
`

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: val(--primary-contrast);
  align-items: center;
  height: 100%;
  overflow: auto;

  .bodyForm {
    font-size: var(--typography-body-1-bold-size);
    color: var(--text-primary);
    font-family: var(--button-large);
    max-width: 32rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 1rem;
  }
  
  .sign-up-form,
  .user-type-1 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .sign-up-form {
    padding: var(--boundvariablesdata1) var(--boundvariablesdata)
    var(--boundvariablesdata2);
    gap: var(--boundvariablesdata);
    text-align: left;
    font-size: var(--typography-body-1-bold-size);
    color: var(--text-primary);
    font-family: var(--button-large);
    max-width: 30rem;
  }
  .user-type-1 {
    background-color: var(--primary-contrast);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    overflow: scroll;
    z-index: 501;
  }

  .roleSelectLabel {
    .MuiTypography-body1 {
      position: relative;
      line-height: 133.4%;
      font-weight: 600;
      font-size: var(--typography-h5-size);
    }
  }

  .office,
  .worker {
    margin-top: 1rem;
    border: 1px solid var(--divider);
    padding: var(--boundvariablesdata);
    font-size: var(--typography-h5-size);
    border-radius: var(--borderradius);
    gap: var(--boundvariablesdata5);
  }

  .worker {
    overflow: hidden;
    justify-content: flex-start;
  }

  .office {
    margin-bottom: 1rem;
    justify-content: center;
  }

  .checklist,
  .office,
  .worker {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--boundvariablesdata5);
    font-size: var(--typography-body-1-bold-size);
  }

  .toLogIn {
    display: flex;
    justify-content: center;
    padding: var(--2, 1rem) 0 0;
    font-size: var(--typography-body-1-bold-size);
    text-align:center;
    white-space: pre;
    color: var(--text-secondary, rgba(0, 0, 0, 0.60));
  }

  .roleSelectSignUp {
    width: 100%;
  }

  .hidden-icon {
    position: relative;
    width: 1.5rem;
    height: 1.5rem;
    overflow: hidden;
    flex-shrink: 0;
  }

  .roleSelectLabel {
    position: relative;
    line-height: 133.4%;
    font-weight: 600;
    font-size: var(--typography-h5-size);
  }

  .always-free {
    flex: 1;
    position: relative;
    letter-spacing: 0.15px;
    line-height: 150%;
  }
  .itemBox {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: var(--boundvariablesdata5);
  }

  .loginBtn {
    text-decoration: underline;
    color: var(--secondary-main);
  }
`

